// extracted by mini-css-extract-plugin
export default {"city":"City_city__pEqOt","map-wrap":"City_map-wrap__TPwqE","map":"City_map__cGQar","title":"City_title__9+ewO"};